import { FriendSentListItemCoreProps } from "../type"
import React from "react"
import { StyleSheet } from "~/ui/primitives"
import { observer } from "mobx-react-lite"
import { Avatar } from "~widgets/avatar"
import { Name, Username } from "~components/text"
import styled from '~/ui/styled'
import { FriendStatus } from "~proto"
import { BetweenFlex, ColumnFlex, Flex, IconFont, StartFlex, Text } from "~components/El"
import { useTheme } from "~/ui/styled"

const Row = styled(Flex)`
  align-items: center;
  flex-direction: row;
`

const UserInfo = ({ name, atUsername }) => (
  <Row>
    <Name name={name} />
    <Username atUsername={atUsername} />
  </Row>
)

const Container = styled(Flex)`
  flex: 1;
  flex-direction: row;
  align-items: center;
  padding: ${({ theme }) => theme.space.sm};
`

const Main = styled(Flex)`
  flex-direction: row;
  justify-content: space-between;
  padding-bottom: 10px;
  margin-left: 10px;
  margin-right: 50px;
  border-bottom-width: ${StyleSheet.hairlineWidth}px;
  border-bottom-color: ${({ theme }) => theme.colors.border};
  border-bottom-style: solid;
`

const formatRelativeTime = (d: Date) => {
  const date = d instanceof Date ? d : new Date(d)
  const now = new Date()
  const diffMs = now.getTime() - date.getTime()
  const diffMin = Math.floor(diffMs / (1000 * 60))
  if (diffMin < 1) return "刚刚"
  if (diffMin < 60) return `${diffMin}分钟前`
  const diffHour = Math.floor(diffMin / 60)
  if (diffHour < 24) return `${diffHour}小时前`

  const t1 = new Date(now.getFullYear(), now.getMonth(), now.getDate())
  const t2 = new Date(date.getFullYear(), date.getMonth(), date.getDate())
  const diffDays = Math.floor((t1.getTime() - t2.getTime()) / (1000 * 60 * 60 * 24))
  if (diffDays === 1) return "昨天"
  return `${date.getMonth() + 1}-${date.getDate()}`
}
const statusUI: Record<FriendStatus, { text: string; icon: string; color: string }> = {
  [FriendStatus.PENDING]: { text: "等待对方确认", icon: "time", color: "#ff9a35" },
  [FriendStatus.APPROVED]: { text: "已同意", icon: "cg", color: "#07c160" },
  [FriendStatus.REJECTED]: { text: "已拒绝", icon: "close", color: "#a2a8af" },
  [FriendStatus.EXPIRED]: { text: "已过期", icon: "close", color: "#a2a8af" },
}
export const FriendSentListItemCore: React.FC<FriendSentListItemCoreProps> = ({ friend, onAccept, onReject }) => {
  const theme = useTheme()
  const f: any = friend as any
  const ui = statusUI[f.status as FriendStatus] || statusUI[FriendStatus.PENDING]
  return (
    <Container>
      <Avatar avatar={f.user?.avatar} name={f.name} />
      <Main height="auto" > 
        <BetweenFlex flex={1} pr="0px">
          <ColumnFlex height="auto"  gap="4px">
            <UserInfo name={f.user?.name} atUsername={f.user?.username} />
            <StartFlex gap="6px">
              <IconFont name={ui.icon} size={12} color={ui.color} />
              <Text color={ui.color} fontSize={12}>{ui.text}</Text>
            </StartFlex>
          </ColumnFlex>
          <StartFlex minWidth={'max-content'} height="auto" width="auto">
            <Text minWidth={'max-content'} color={theme.colors.secondaryText} fontSize={12}>
              {formatRelativeTime(f.created as any)}
            </Text>
          </StartFlex>
          
        </BetweenFlex>
      </Main>
    </Container>
  )
}

export default observer(FriendSentListItemCore)
